import { ITrack, Track } from './track';

export class CrossOver {

  location: string;
  fromTrack: Track;
  toTrack: Track;
  lineNumber: string;
  sequence: number;
  cancelledDate: Date;

  constructor(crossOver: ICrossOver) {
    this.location = crossOver.location;
    this.fromTrack = new Track(crossOver.fromTrack);
    this.toTrack = new Track(crossOver.toTrack);
    this.lineNumber = crossOver.lineNumber;
    this.sequence = crossOver.sequence;
    this.cancelledDate = crossOver.cancelledDate === undefined ? undefined : new Date(crossOver.cancelledDate);
  }
}

export interface ICrossOver {

  location: string;
  fromTrack: ITrack;
  toTrack: ITrack;
  lineNumber: string;
  sequence: number;
  cancelledDate: number;
}
